<template>
  <v-data-table-server
    v-model:options="options"
    dense
    :headers="headers"
    :loading="loading"
    :items="items"
    :items-length="totalItems"
    class="elevation-1"
    :items-per-page-options="footerProps.itemsPerPageOptions"
    @update:options="updateTable"
  >
    <template #top>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>OFAC Reports</v-toolbar-title>
        </v-toolbar>
      </v-card-title>
    </template>

    <template #item.report_file="{ item }">
      <div
        :title="item.report_file"
      >
        {{ item.report_file }}
      </div>
    </template>

    <template #item.return_file="{ item }">
      <div
        style="max-width: 120px;"
        :title="item.return_file"
      >
        {{ item.return_file }}
      </div>
    </template>

    <template #item.created_at="{ item }">
      {{ formatDateTime(item.created_at) }}
    </template>

    <template #item.updated_at="{ item }">
      {{ formatDateTime(item.updated_at) }}
    </template>

    <template #item.actions="{ item }">
      <v-menu
        v-if="item.return_file"
        offset-y
      >
        <template #activator="{ props }">
          <v-btn
            color="primary"
            dark
            small
            v-bind="props"
          >
            Review
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="{ name: 'ofac-matches', query: { id: item.id } }">
            <v-list-item-title>All</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'ofac-matches', query: { id: item.id, status: 'open' } }">
            <v-list-item-title>Outstanding</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'ofac-matches', query: { id: item.id, status: 'confirmed' } }">
            <v-list-item-title>Confirmed</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'ofac-matches', query: { id: item.id, status: 'false' } }">
            <v-list-item-title>False</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table-server>
</template>

<script>
import { DateTime } from 'luxon';
import dataTableMixin from '@/mixins/dataTableMixin.js';

export default {
  name: 'OfacUploadsIndex',
  mixins: [
    dataTableMixin,
  ],
  data: () => ({
    headers: [
      { title: 'ID', value: 'id' },
      { title: 'Status', value: 'status' },
      { title: 'Report File', value: 'report_file' },
      { title: 'Report Time', value: 'report_time' },
      { title: 'Upload File', value: 'upload_file' },
      { title: 'Upload Time', value: 'upload_time' },
      { title: 'Return File', value: 'return_file' },
      { title: 'Return Time', value: 'return_time' },
      { title: 'Created On', value: 'created_at' },
      { title: 'Last Update', value: 'updated_at' },
      { title: 'Actions', value: 'actions', sortable: false },
    ],
    returnFileToolTip: false,
  }),
  methods: {
    updateTable() {
      this.loading = true;

      return this.$axios
        .get('api/v1/ofac-report', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
            search: this.search,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;
        });
    },

    formatDateTime(date) {
      return DateTime.fromISO(date).toUTC().toFormat('yyyy-MM-dd HH:mm:ss');
    },
  },
};
</script>

<style scoped>
.v-list-item {
  cursor: pointer;
}
</style>
